import { render } from "./question-gaps-component.vue?vue&type=template&id=103f5cd0&ts=true"
import script from "./question-gaps-component.vue?vue&type=script&lang=ts"
export * from "./question-gaps-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__